import React, { Fragment, useState, useContext, useEffect } from "react";
import { AuthContext } from "../../context/AuthContext";
import { useNavigate, useLocation } from "react-router";
import FMenuCard from "../../components/FMenuCard/FMenuCard";
import { usePhoneFormat } from "../../hooks/usePhoneFormat";
import { getProductById } from "../../api/spend";
import { deleteShortcut } from "../../api/shortcut";
import { useFormik } from "formik";
import * as Yup from "yup";
import FInputt from "../../components/FInputt/FInputt";
import { useLogin } from "../Login/hooks/useLogin";
import FInputText from "../../components/Finputs/FInputText/FInputText";
import Fselect from "../../components/Finputs/Fselect/Fselect";
import Fbutton from "../../components/Finputs/FButton/Fbutton";
import { useFormat } from "../../hooks/useFormat";

const RechargeOptionScreen = ({ param }) => {
  const { urlImage } = useFormat();

  const { formik } = useLogin();

  const route = useNavigate();
  const { state } = useLocation();

  const { checkToken } = useContext(AuthContext);
  const [rechargeInfo, setRechargeInfo] = useState([]);
  const [availableAmount, setAvailableAmount] = useState([]);

  const [value, setValue] = useState("");

  const {
    typingPhoneNumber,
    formatNumberToNationalWithoutSpaces,
    validateLocalPhone,
    inputFormatValidation,
  } = usePhoneFormat();

  const getRechargeInfo = async () => {
    checkToken()
    try {
      const { data } = await getProductById(state?.id);
      setRechargeInfo(data.data);
      let transform = transformAvailableAmount(
        data.data.requirements.availableAmount
      );
      formikRechargeScreen.setFieldValue("amount", transform[0]);
      setAvailableAmount(transform);
    } catch (e) {
      console.log(e);
    }
  };

  const transformAvailableAmount = (availableAmount) => {
    let amounts = [];

    availableAmount = availableAmount.sort(function (a, b) {
      return a - b;
    });

    for (const amount of availableAmount) {
      let myAmount = {
        id: amount,
        value: `$${amount.toString()}`,
      };

      amounts.push(myAmount);
    }

    return amounts;
  };

  useEffect(() => {
    async function gPaymentAccountNumber() {
      //console.log(rechargeInfo.currencyId);
      if (state?.product) {
        await formikRechargeScreen.setFieldValue(
          "paymentAccountNumber",
          "+52" + state?.product?.accountNumber
        );
        formikRechargeScreen.setFieldValue(
          "amount",
          state.product?.requirements?.availableAmount[0]
        );
        setValue(typingPhoneNumber(state?.product?.accountNumber));
        //console.log('definido')
        await formikRechargeScreen.setFieldValue(
          "paymentAccountNumber",
          "+52" + state.product.accountNumber
        );
      } else {
        //console.log('no definido')
      }

      //console.log(value)
      getRechargeInfo();
    }

    gPaymentAccountNumber();
  }, []);

  useEffect(() => {
    formikRechargeScreen.setFieldValue("description", rechargeInfo.displayName);
  }, [rechargeInfo]);

  const nextScreen = async ({ paymentAccountNumber, amount, description }) => {
    let data = {
      originCurrencyId: 484,
      destinationCurrencyId: 484,
      sourceDirectoryId: JSON.parse(localStorage.getItem("tokenDecoded")),
      products: [
        {
          id: state.id ? state.id : state.product.id,
          amount: amount,
          paymentAccountNumber: paymentAccountNumber,
          description: "",
        },
      ],
    };

    if (state?.product?.id) {
      var comeFromFavorites = true;
    } else {
      var comeFromFavorites = false;
    }

    route("/BillScreen2", {
      state: {
        data: data,
        comeFromFavorites: comeFromFavorites,
      },
    });
  };

  const validate = Yup.object({
    paymentAccountNumber: Yup.number()
      .typeError("Ingrese un número de celular válido")
      .required("Número de celular requerido")
      .test(
        "Validate Phone Number",
        "Ingrese un número de celular válido",
        (value) => validateLocalPhone("+" + value) == true
      ),
    // description: Yup.string()
    // .required('Ingresa una descripción'),
  });

  const formikRechargeScreen = useFormik({
    initialValues: {
      paymentAccountNumber: "",
      amount: "",
      description: "",
    },
    onSubmit: (values) => {
      const { paymentAccountNumber, amount, description } = values;
      let number = formatNumberToNationalWithoutSpaces(paymentAccountNumber);
      let amountQty = parseFloat(amount.id);
      nextScreen({
        paymentAccountNumber: number,
        amount: amountQty,
        description,
      });
    },
    validationSchema: validate,
  });

  useEffect(() => {}, [formikRechargeScreen.values]);

  return (
    <>
      {state != null ? (
        <>
          <div className="w-full grid place-items-center">
            <form
              onSubmit={formikRechargeScreen.handleSubmit}
              className="sm:w-[500px]"
            >
              <div className="py-4 border-0 border-dashed p-3 mb-16 grid place-items-center">
                <img
                  src={state.iconUrl ? state.iconUrl : state.product?.iconUrl}
                  className="w-32 sm:w-48"
                />

                {state.product?.description ? (
                  <div pink bold large>
                    {state.product.description}
                  </div>
                ) : null}

                {state.product?.description ? (
                  <div pink bold large>
                    {state.value}
                  </div>
                ) : null}

                {state.product?.description ? null : (
                  <FInputText
                    title="Número de celular"
                    onlyCountries={["mx"]}
                    type="PhoneInput"
                    value={formikRechargeScreen.values.paymentAccountNumber}
                    onChange={(value) => {
                      formikRechargeScreen.setFieldValue(
                        "paymentAccountNumber",
                        value
                      );
                    }}
                    errorMessage={
                      formikRechargeScreen.values.paymentAccountNumber == "" ? "" : formikRechargeScreen.errors.paymentAccountNumber
                    }
                  />
                )}

                {state.product?.requirements?.availableAmount ? null : (
                  <Fselect
                    type="SelectIcon"
                    title="Monto (MXN)"
                    placeholder="Selecciona un monto (MXN)"
                    options={availableAmount}
                    value={availableAmount[0]}
                    onChange={(value) => {
                      formikRechargeScreen.setFieldValue("amount", value);
                    }}
                    errorMessage={formikRechargeScreen.errors.amount}
                  />
                )}
                <Fbutton
                  value={"Recargar"}
                  disabled={!formikRechargeScreen.isValid}
                  onClick={formikRechargeScreen.handleSubmit}
                />
              </div>
            </form>
          </div>
        </>
      ) : (
        route("/")
      )}
    </>
  );
};

export default RechargeOptionScreen;
